import { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import axiosInstance from "../axiosInstance";
import { getImageUrl } from "../imageUrl";

import CreateQuery from "./CreateQuery";
import EditQuery from "./EditQuery";
import ViewQueryModel from "../components/ViewQueryModel";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Calendar } from "primereact/calendar";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";




import {
  BiEditAlt,
  BiSearch,
  BiCalendar,
  BiRefresh,
  BiPlus,
  BiImage,
} from "react-icons/bi";

import {
  MdDelete,
  MdClose,
  MdOutlineDescription,
  MdOutlinePendingActions,
  MdCheckCircleOutline,
  MdOutlineQueryStats,
  MdOutlineErrorOutline,
} from "react-icons/md";

import { RiFilter3Line } from "react-icons/ri";

export default function ClientDashboard() {
  const API = process.env.REACT_APP_API_URL;

  // =========================================================
  // STATE
  // =========================================================

  const [queries, setQueries] = useState([]);
  const [modalType, setModalType] = useState("");
  const [visible, setVisible] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const [openModal, setOpenModal] = useState(false);
  const [viewQuery, setViewQuery] = useState(null);

  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [queryHeading, setQueryHeading] = useState("");
  const [queryDescription, setQueryDescription] = useState(null);

 const [buildingBlock, setBuildingBlock] = useState("");
const [priority, setPriority] = useState("Medium");

const [departments, setDepartments] = useState([]);
const [requestedDepartment, setRequestedDepartment] = useState("");
const [assignedDepartment, setAssignedDepartment] = useState("");
const [
  requestedDepartmentUser,
  setRequestedDepartmentUser
] = useState("");

  const [selectedId, setSelectedId] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);

  const [preview, setPreview] = useState("");

  const [dates, setDates] = useState(null);

  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const toast = useRef(null);

  // =========================================================
  // FETCH DATA
  // =========================================================

 useEffect(() => {
  const token = localStorage.getItem("token");

  if (!token) {
    console.log("token not found");
    setLoading(false);
    return;
  }

  fetchQueries();
  fetchDepartments();
}, []);

  const fetchQueries = async () => {
    try {
      setLoading(true);
      setError("");

      const userId = localStorage.getItem("user_id");

      const res = await axiosInstance.get(
        `${API}/api/query/list/${userId}/`
      );

      setQueries(res.data || []);
    } catch (err) {
      console.log("error fetch queries", err);
      setError("Unable to load queries. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const fetchDepartments = async () => {
  try {
    const res = await axiosInstance.get(
      `${API}/api/get/dep/`
    );

    setDepartments(res.data || []);

    console.log(
      "Departments:",
      res.data
    );
  } catch (err) {
    console.log(
      "Error fetching departments:",
      err
    );
  }
};

  // =========================================================
  // DATE FORMAT
  // =========================================================

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const d = new Date(dateString);

    if (Number.isNaN(d.getTime())) {
      return "";
    }

    return (
      d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      }) +
      " " +
      d.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
      })
    );
  };

  // =========================================================
  // FILTERED DATA
  // =========================================================

  const filterqueries = useMemo(() => {
    let result = [...queries];

    // -----------------------------
    // DATE FILTER
    // -----------------------------

    if (dates && dates[0] && dates[1]) {
      const start = new Date(dates[0]);

      const end = new Date(dates[1]);
      end.setHours(23, 59, 59, 999);

      result = result.filter((q) => {
        const created = new Date(q.query_created_time);

        return created >= start && created <= end;
      });
    }

    // -----------------------------
    // STATUS FILTER
    // -----------------------------

    if (statusFilter) {
      const normalizedFilter = statusFilter.toLowerCase();

      result = result.filter((q) => {
        const status = String(q.status || "").toLowerCase();

        if (normalizedFilter === "open") {
          return status !== "completed" && status !== "closed";
        }

        return status === normalizedFilter;
      });
    }

    // -----------------------------
    // SEARCH FILTER
    // -----------------------------

    if (searchTerm.trim()) {
      const search = searchTerm.toLowerCase().trim();

      result = result.filter((q) => {
        return (
          String(q.query_heading || "")
            .toLowerCase()
            .includes(search) ||
          String(q.query_description || "")
            .toLowerCase()
            .includes(search) ||
          String(q.requested_department_user || "")
            .toLowerCase()
            .includes(search) ||
          String(q.requested_department || "")
            .toLowerCase()
            .includes(search) ||
          String(q.department || "")
            .toLowerCase()
            .includes(search) ||
          String(q.status || "")
            .toLowerCase()
            .includes(search) ||
          String(q.closed_by || "")
            .toLowerCase()
            .includes(search)
        );
      });
    }

    return result;
  }, [queries, dates, searchTerm, statusFilter]);

  // =========================================================
  // STATISTICS
  // =========================================================

  const totalQueries = queries.length;

  const pendingQueries = queries.filter(
    (q) => String(q.status || "").toLowerCase() === "pending"
  ).length;

  const completedQueries = queries.filter(
    (q) => String(q.status || "").toLowerCase() === "completed"
  ).length;

  const openQueries = queries.filter((q) => {
    const status = String(q.status || "").toLowerCase();

    return status !== "completed" && status !== "closed";
  }).length;

  // =========================================================
  // RESET FILTERS
  // =========================================================

  const resetFilters = () => {
    setDates(null);
    setSearchTerm("");
    setStatusFilter("");
  };

  const selectStatFilter = (filter) => {
    setStatusFilter(filter);
  };

  // =========================================================
  // DELETE QUERY
  // =========================================================

  const acceptDelete = async () => {
    try {
      await axios.delete(
        `${API}/api/query/delete/${deleteId}/`
      );

      await fetchQueries();

      setVisible(false);
      setDeleteId(null);

      toast.current?.show({
        severity: "success",
        summary: "Deleted",
        detail: "Query deleted successfully.",
        life: 3000,
      });
    } catch (err) {
      console.log("Delete error:", err);

      toast.current?.show({
        severity: "error",
        summary: "Delete failed",
        detail: "Unable to delete the query. Please try again.",
        life: 3000,
      });
    }
  };

  const rejectDelete = () => {
    setVisible(false);
    setDeleteId(null);

    toast.current?.show({
      severity: "warn",
      summary: "Cancelled",
      detail: "Delete cancelled.",
      life: 2500,
    });
  };

  // =========================================================
  // UPDATE QUERY
  // =========================================================

  const Updatequery = async () => {
    const formData = new FormData();

    try {
      const userId = localStorage.getItem("user_id");

      formData.append("user_id", userId || "");
      formData.append("email", email);
      formData.append("mobile", mobile);
      formData.append("query_heading", queryHeading);
      formData.append("query_description", queryDescription || "");
      formData.append("building_block", buildingBlock);

      formData.append(
        "requested_department",
        requestedDepartment
      );

      formData.append(
        "department",
        assignedDepartment
      );

formData.append(
  "priority",
  priority || "Medium"
);

      if (selectedImage) {
        formData.append("image", selectedImage);
      }

      const res = await axios.put(
        `${API}/api/query/update/${selectedId}/`,
        formData
      );

      console.log("updatequery", res.data);

      await fetchQueries();

      setOpenModal(false);
      setSelectedImage(null);

      toast.current?.show({
        severity: "success",
        summary: "Updated",
        detail: "Query updated successfully.",
        life: 3000,
      });
    } catch (err) {
      console.log("error update query", err);

      toast.current?.show({
        severity: "error",
        summary: "Update failed",
        detail: "Unable to update the query. Please try again.",
        life: 3000,
      });
    }
  };

  // =========================================================
  // STATUS BADGE
  // =========================================================

  const statusBodyTemplate = (rowData) => {
    const status = String(rowData.status || "");

    const normalizedStatus = status.toLowerCase();

    let styles =
      "bg-slate-100 text-slate-700 border-slate-200";

    let dot = "bg-slate-500";

    if (normalizedStatus === "pending") {
      styles =
        "bg-amber-50 text-amber-700 border-amber-200";

      dot = "bg-amber-500";
    }

    if (normalizedStatus === "completed") {
      styles =
        "bg-emerald-50 text-emerald-700 border-emerald-200";

      dot = "bg-emerald-500";
    }

    if (normalizedStatus === "closed") {
      styles =
        "bg-slate-100 text-slate-600 border-slate-200";

      dot = "bg-slate-500";
    }

    if (
      normalizedStatus === "rejected" ||
      normalizedStatus === "failed"
    ) {
      styles =
        "bg-red-50 text-red-700 border-red-200";

      dot = "bg-red-500";
    }

    return (
      <span
        className={`
          inline-flex
          items-center
          gap-2
          px-2.5
          py-1
          rounded-full
          border
          text-xs
          font-semibold
          whitespace-nowrap
          ${styles}
        `}
      >
        <span
          className={`w-1.5 h-1.5 rounded-full ${dot}`}
        />

        {status || "Unknown"}
      </span>
    );
  };

   // QUERY HEADING
  // =========================================================

  const ticketIdBodyTemplate = (rowData) => {
    return (
      <div
        className="max-w-[190px] "
        title={rowData.id || ""}
      >
        <p className="font-semibold text-slate-800 truncate ">
          {rowData.id || "-"}
        </p>
      </div>
    );
  };

  // =========================================================
  // QUERY HEADING
  // =========================================================

  const headingBodyTemplate = (rowData) => {
    return (
      <div
        className="max-w-[180px]"
        title={rowData.query_heading || ""}
      >
        <p className=" text-slate-800 truncate">
          {rowData.query_heading || "-"}
        </p>
      </div>
    );
  };

  // =========================================================
  // DESCRIPTION
  // =========================================================

  // const descriptionBodyTemplate = (rowData) => {
  //   return (
  //     <div
  //       className="max-w-[260px]"
  //       title={rowData.requested_department_user|| ""}
  //     >
  //       <div className="flex items-start gap-2">
  //         <MdOutlineDescription
  //           size={16}
  //           className="text-slate-400 mt-0.5 flex-shrink-0"
  //         />

  //         <p className="text-sm text-slate-600 truncate">
  //           {rowData.requested_department_user || "-"}
  //         </p>
  //       </div>
  //     </div>
  //   );
  // };

  // REQUESTED DEPARTMENT AND USER
  const requestedDepartmentUserBodyTemplate = (rowData) => {
    return rowData.requested_department_user ? (
      <span
        className="inline-flex items-center  ">
        {rowData.requested_department_user}
      </span>
    ) : (
      <span className="text-slate-400">—</span>
    );
  };

  const requestedDepartmentBodyTemplate = (rowData) => {
    return rowData.requested_department ? (
      <span
        className="">
        {rowData.requested_department}
      </span>
    ) : (
      <span className="text-slate-400">—</span>
    );
  };

  // =========================================================
  // DEPARTMENT
  // =========================================================

  const departmentBodyTemplate = (rowData) => {
    return rowData.department ? (
      <span
        className="">
        {rowData.department}
      </span>
    ) : (
      <span className="text-slate-400">—</span>
    );
  };

  // =========================================================
  // IMAGE
  // =========================================================

  const imageBodyTemplate = (rowData) => {
    const image = rowData.completed_image || rowData.image;

    if (!image) {
      return (
        <div
          className="
            w-10
            h-10
            rounded-lg
            bg-slate-100
            border
            border-slate-200
            flex
            items-center
            justify-center
          "
        >
          <BiImage
            size={18}
            className="text-slate-400"
          />
        </div>
      );
    }

    return (
      <button
        type="button"
        onClick={() => setPreview(image)}
        title="View image"
        className="
          group
          relative
          w-11
          h-11
          rounded-lg
          overflow-hidden
          border
          border-slate-200
          bg-slate-100
          cursor-pointer
        "
      >
        <img
          src={getImageUrl(image, API)}
          alt="Query attachment"
          className="
            w-full
            h-full
            object-cover
            transition-transform
            duration-200
            group-hover:scale-110
          "
        />

        <div
          className="
            absolute
            inset-0
            bg-black/30
            opacity-0
            group-hover:opacity-100
            transition
            flex
            items-center
            justify-center
          "
        >
          <BiImage
            size={16}
            className="text-white"
          />
        </div>
      </button>
    );
  };

  // =========================================================
  // DATE BODY
  // =========================================================

  const createdDateBodyTemplate = (rowData) => {
    const value = formatDate(rowData.query_created_time);

    return value ? (
      <span className="text-sm text-slate-600 whitespace-nowrap">
        {value}
      </span>
    ) : (
      <span className="text-slate-400">—</span>
    );
  };

  const closedDateBodyTemplate = (rowData) => {
    const value = formatDate(rowData.query_closed_time);

    return value ? (
      <span className="text-sm text-slate-600 whitespace-nowrap">
        {value}
      </span>
    ) : (
      <span className="text-slate-400">—</span>
    );
  };

  // =========================================================
  // CLOSED BY
  // =========================================================

  const closedByBodyTemplate = (rowData) => {
    return rowData.closed_by ? (
      <span className="text-sm font-medium text-slate-700">
        {rowData.closed_by}
      </span>
    ) : (
      <span className="text-slate-400">—</span>
    );
  };

  // =========================================================
  // ACTIONS
  // =========================================================

  const actionBodyTemplate = (row) => {
    const status = String(row.status || "").toLowerCase();

    const completed =
      status === "completed" ||
      status === "closed";

    return (
      <div className="flex items-center gap-1.5 whitespace-nowrap">

        {/* =================================================
          VIEW - COMPLETED / CLOSED
      ================================================= */}

        {completed && (
          <button
            type="button"
            title="View completed query"
            onClick={() => {
              setViewQuery(row);
            }}
            className="
            inline-flex
            items-center
            justify-center
            gap-1.5
            px-2.5
            py-1.5
            rounded-lg
            border
            border-emerald-200
            bg-white
            text-emerald-700
            text-xs
            font-medium
            hover:bg-emerald-50
            hover:border-emerald-300
            transition
          "
          >
            <MdOutlineDescription size={15} />
            View
          </button>
        )}

        {/* =================================================
          EDIT - ONLY OPEN/PENDING
      ================================================= */}

        {!completed && (
          <button
            type="button"
            title="Edit query"
            onClick={() => {

              setSelectedId(row.id);

              setQueryHeading(
                row.query_heading || ""
              );

              setQueryDescription(
                row.query_description || ""
              );
              setBuildingBlock(
                row.building_block || ""
              );

              setEmail(
                row.email || ""
              );

              setMobile(
                row.mobile || ""
              );

              setRequestedDepartmentUser(
                row.requested_department_user || ""
              );

              setRequestedDepartment(
                row.requested_department || ""
              );

              const assignedDept = departments.find(
                (dept) => dept.name === row.department
              );

              setAssignedDepartment(
                assignedDept
                  ? String(assignedDept.id)
                  : ""
              );

              setPriority(
                row.priority || "Medium"
              );

              setSelectedImage(null);

              setModalType("edit");
              setOpenModal(true);
            }}
            className="
            inline-flex
            items-center
            justify-center
            gap-1.5
            px-2.5
            py-1.5
            rounded-lg
            border
            border-sky-200
            bg-white
            text-sky-700
            text-xs
            font-medium
            hover:bg-sky-50
            hover:border-sky-300
            transition
          "
          >
            <BiEditAlt size={15} />
            Edit
          </button>
        )}

        {/* =================================================
          DELETE
      ================================================= */}

        {/* <button
  type="button"
  title={row.status === "Completed" ? "Completed tickets cannot be deleted" : "Delete query"}
  disabled={row.status === "Completed"}
  onClick={() => {
    setDeleteId(row.id);
    setVisible(true);
  }}
  className="
    inline-flex
    items-center
    justify-center
    gap-1.5
    px-2.5
    py-1.5
    rounded-lg
    border
    border-red-200
    bg-white
    text-red-600
    text-xs
    font-medium
    transition
    disabled:cursor-not-allowed
    disabled:opacity-50
    disabled:hover:bg-white
    disabled:hover:border-red-200
  "
>
  <MdDelete size={15} />
</button> */}


      </div>
    );
  };

  // =========================================================
  // STAT CARD
  // =========================================================

  const StatCard = ({
    title,
    value,
    subtitle,
    icon,
    iconStyle,
    onClick,
  }) => {
    return (
      <button
        type="button"
        onClick={onClick}
        className="
          w-full
          text-left
          bg-white
          border
          border-slate-200
          rounded-xl
          p-4
          shadow-sm
          hover:shadow-md
          transition-shadow
        "
      >
        <div className="flex items-start justify-between gap-3">

          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
              {title}
            </p>

            <p className="mt-2 text-2xl font-bold text-slate-800">
              {value}
            </p>

            <p className="mt-1 text-xs text-slate-400">
              {subtitle}
            </p>
          </div>

          <div
            className={`
              w-10
              h-10
              rounded-lg
              flex
              items-center
              justify-center
              flex-shrink-0
              ${iconStyle}
            `}
          >
            {icon}
          </div>
        </div>
      </button>
    );
  };

  // =========================================================
  // RENDER
  // =========================================================

  return (
    <div className="w-full min-h-screen mt-10 bg-slate-50">

      {/* =====================================================
          PAGE CONTAINER
      ===================================================== */}

      <div className="w-full max-w-[1800px] mx-auto">

        {/* ===================================================
            PAGE HEADER
        =================================================== */}

        <div
          className="
            bg-white
            border
            border-slate-200
            rounded-xl
            shadow-sm
            px-4
            sm:px-5
            lg:px-6
            py-4
            sm:py-5
            mb-5
          "
        >
          <div
            className="
              flex
              flex-col
              sm:flex-row
              sm:items-center
              sm:justify-between
              gap-4
            "
          >

            <div>
              <div className="flex items-center gap-2">
                <div
                  className="
                    w-9
                    h-9
                    rounded-lg
                    bg-sky-50
                    text-sky-600
                    flex
                    items-center
                    justify-center
                  "
                >
                  <MdOutlineQueryStats size={21} />
                </div>

                <h1 className="text-xl sm:text-2xl font-bold text-slate-800">
                  Queries
                </h1>
              </div>

              {/* <p className="mt-1 text-sm text-slate-500">
                Manage and track all submitted queries
              </p> */}
            </div>

            {/* CREATE BUTTON */}
            <button
              type="button"
              onClick={() => {
                setModalType("create");
                setOpenModal(true);
              }}
              className="
                inline-flex
                items-center
                justify-center
                gap-2
                w-full
                sm:w-auto
                px-4
                py-2.5
                rounded-lg
                bg-sky-600
                hover:bg-sky-700
                text-white
                text-sm
                font-semibold
                shadow-sm
                hover:shadow
                transition
              "
            >
              <BiPlus size={19} />
              Create Query
            </button>
          </div>
        </div>

        {/* ===================================================
            KPI CARDS
        =================================================== */}

        <div
          className="
            grid
            grid-cols-1
            sm:grid-cols-2
            xl:grid-cols-4
            gap-3
            sm:gap-4
            mb-5
          "
        >
          <StatCard
            title="Total Queries"
            value={totalQueries}
            subtitle="All submitted queries"
            icon={<MdOutlineQueryStats size={21} />}
            iconStyle="bg-sky-50 text-sky-600"
            onClick={() => selectStatFilter("")}
          />

          <StatCard
            title="Pending"
            value={pendingQueries}
            subtitle="Awaiting resolution"
            icon={<MdOutlinePendingActions size={21} />}
            iconStyle="bg-amber-50 text-amber-600"
            onClick={() => selectStatFilter("Pending")}
          />

          <StatCard
            title="Completed"
            value={completedQueries}
            subtitle="Successfully completed"
            icon={<MdCheckCircleOutline size={21} />}
            iconStyle="bg-emerald-50 text-emerald-600"
            onClick={() => selectStatFilter("Completed")}
          />

          <StatCard
            title="Open"
            value={openQueries}
            subtitle="Currently active"
            icon={<MdOutlineErrorOutline size={21} />}
            iconStyle="bg-indigo-50 text-indigo-600"
            onClick={() => selectStatFilter("Open")}
          />
        </div>

        {/* ===================================================
            FILTER TOOLBAR
        =================================================== */}

        <div
          className="
            
            
            border-slate-200
            rounded-xl
           
            p-4
            mb-5
          "
        >
          {/* <div className="flex items-center gap-2 mb-3">
            <RiFilter3Line
              size={18}
              className="text-slate-500"
            />

            <h2 className="text-sm font-semibold text-slate-700">
              Filters
            </h2>
          </div> */}

          <div
            className="
              flex
              flex-col
              lg:flex-row
              lg:items-center
              gap-3
            "
          >

            {/* SEARCH */}
            <div className="relative w-full lg:flex-1">

              <BiSearch
                size={19}
                className="
                  absolute
                  left-3
                  top-1/2
                  -translate-y-1/2
                  text-slate-400
                "
              />

              <input
                type="text"
                value={searchTerm}
                onChange={(e) =>
                  setSearchTerm(e.target.value)
                }
                placeholder="Search queries, department, status..."
                className="
                  w-1/2
                  h-10
                  pl-10
                  pr-9
                  rounded-lg
                  border
                  border-slate-200
                  bg-white
                  text-sm
                  text-slate-700
                  placeholder:text-slate-400
                  outline-none
                  focus:bg-white
                  focus:border-sky-400
                  focus:ring-2
                  focus:ring-sky-100
                  transition
                "
              />

              {searchTerm && (
                <button
                  type="button"
                  onClick={() => setSearchTerm("")}
                  className="
                    absolute
                    right-2
                    top-1/2
                    -translate-y-1/2
                    w-7
                    h-7
                    flex
                    items-center
                    justify-center
                    rounded-md
                    text-slate-400
                    hover:bg-slate-200
                    hover:text-slate-600
                  "
                >
                  <MdClose size={17} />
                </button>
              )}
            </div>

            {/* DATE */}
            <div className="w-full lg:w-auto border-2  rounded-md ">

              <Calendar
                value={dates}
                onChange={(e) => setDates(e.value)}
                selectionMode="range"
                readOnlyInput
                hideOnRangeSelection
                showIcon
                placeholder="Select date range"
                className="w-full px-2"
                inputClassName="
                  w-full
                  h-10
                  text-sm

                "
              />
            </div>

            {/* STATUS */}
            <select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
              className="h-10 w-full lg:w-40 rounded-lg border border-slate-200 bg-white px-3 text-sm text-slate-700 outline-none focus:border-sky-400 focus:ring-2 focus:ring-sky-100"
              aria-label="Filter by status"
            >
              <option value="">All statuses</option>
              <option value="Pending">Pending</option>
              <option value="In Progress">In Progress</option>
              <option value="Hold">Hold</option>
              <option value="Completed">Completed</option>
              <option value="Open">Open</option>
            </select>

            {/* CLEAR */}
            <button
              type="button"
              onClick={resetFilters}
              className="
                inline-flex
                items-center
                justify-center
                gap-2
                h-10
                px-3.5
                rounded-lg
                border
                border-slate-200
                bg-white
                text-slate-600
                text-sm
                font-medium
                hover:bg-slate-50
                transition
              "
            >
              <BiRefresh size={17} />
              Reset
            </button>

          </div>

          {/* FILTER RESULT */}
          {/* <div className="mt-3 pt-3 border-t border-slate-100">
            <p className="text-xs text-slate-500">
              Showing{" "}
              <span className="font-semibold text-slate-700">
                {filterqueries.length}
              </span>{" "}
              of{" "}
              <span className="font-semibold text-slate-700">
                {queries.length}
              </span>{" "}
              queries
            </p>
          </div> */}
        </div>

        {/* ===================================================
            MODALS
        =================================================== */}

        {/* CREATE */}

        {openModal && modalType === "create" && (
          <CreateQuery
            closeModal={() => setOpenModal(false)}
            refresh={fetchQueries}
          />
        )}

        {/* EDIT */}

        {openModal && modalType === "edit" && (
          <EditQuery
            closeModal={() => setOpenModal(false)}
            onUpdate={Updatequery}

            queryHeading={queryHeading}
            queryDescription={queryDescription}
            email={email}
            mobile={mobile}

            building_block={buildingBlock}



            requested_department_user={
              requestedDepartmentUser
            }

            requestedDepartment={
              requestedDepartment
            }

            assignedDepartment={
              assignedDepartment
            }

            setRequestedDepartment={
              setRequestedDepartment
            }

            setAssignedDepartment={
              setAssignedDepartment
            }

            priority={priority}

            setPriority={
              setPriority
            }

            setQueryHeading={setQueryHeading}
            departments={departments}
            setQueryDescription={setQueryDescription}
            setEmail={setEmail}
            setMobile={setMobile}

            setBuildingBlock={
              setBuildingBlock
            }

            setRequestedDepartmentUser={
              setRequestedDepartmentUser
            }

            selectedImage={selectedImage}
            setSelectedImage={setSelectedImage}
          />
        )}

        {/* VIEW */}

        {viewQuery && (
          <ViewQueryModel
            query={viewQuery}
            close={() => setViewQuery(null)}
            refresh={fetchQueries}
          />
        )}

        {/* ===================================================
            TOAST
        =================================================== */}

        <Toast ref={toast} />

        {/* ===================================================
            DELETE CONFIRMATION
        =================================================== */}

        <ConfirmDialog
          visible={visible}
          onHide={() => {
            setVisible(false);
            setDeleteId(null);
          }}
          message="Are you sure you want to delete this query? This action cannot be undone."
          header="Delete Query"
          icon="pi pi-exclamation-triangle"
          accept={acceptDelete}
          reject={rejectDelete}
        />

        {/* ===================================================
            IMAGE PREVIEW
        =================================================== */}

        {preview && (
          <div
            className="
              fixed
              inset-0
              z-[100]
              bg-slate-950/75
              backdrop-blur-sm
              flex
              items-center
              justify-center
              p-4
            "
            onClick={() => setPreview("")}
          >
            <div
              className="
                relative
                max-w-[95vw]
                max-h-[92vh]
                bg-white
                rounded-xl
                shadow-2xl
                p-2
              "
              onClick={(e) => e.stopPropagation()}
            >

              {/* CLOSE */}
              <button
                type="button"
                onClick={() => setPreview("")}
                className="
                  absolute
                  -right-3
                  -top-3
                  z-10
                  w-9
                  h-9
                  rounded-full
                  bg-white
                  border
                  border-slate-200
                  shadow-lg
                  flex
                  items-center
                  justify-center
                  text-slate-600
                  hover:text-red-600
                  hover:bg-red-50
                  transition
                "
                aria-label="Close image preview"
              >
                <MdClose size={20} />
              </button>

              <img
                src={getImageUrl(preview, API)}
                alt="Query preview"
                className="
                  max-w-[90vw]
                  max-h-[85vh]
                  object-contain
                  rounded-lg
                "
              />
            </div>
          </div>
        )}

        {/* ===================================================
            ERROR STATE
        =================================================== */}

        {error && !loading && (
          <div
            className="
              bg-white
              border
              border-red-200
              rounded-xl
              shadow-sm
              p-8
              mb-5
              text-center
            "
          >
            <div
              className="
                mx-auto
                w-12
                h-12
                rounded-full
                bg-red-50
                text-red-500
                flex
                items-center
                justify-center
                mb-3
              "
            >
              <MdOutlineErrorOutline size={25} />
            </div>

            <h3 className="text-sm font-semibold text-slate-800">
              Unable to load queries
            </h3>

            <p className="mt-1 text-sm text-slate-500">
              {error}
            </p>

            <button
              type="button"
              onClick={fetchQueries}
              className="
                mt-4
                inline-flex
                items-center
                gap-2
                px-4
                py-2
                rounded-lg
                bg-sky-600
                hover:bg-sky-700
                text-white
                text-sm
                font-medium
                transition
              "
            >
              <BiRefresh size={17} />
              Try Again
            </button>
          </div>
        )}

        {/* ===================================================
            TABLE
        =================================================== */}

        {!error && (
          <div
            className="
              bg-white
              border
              border-slate-200
              rounded-xl
              shadow-sm
              overflow-hidden
            "
          >

            {/* TABLE HEADER */}
            <div
              className="
                px-4
                sm:px-5
                
                flex
                flex-col
                sm:flex-row
                sm:items-center
                sm:justify-between
                gap-2
              "
            >
              <div>
                {/* <h2 className="text-sm font-semibold text-slate-800">
                  Query Records
                </h2> */}

                {/* <p className="text-xs text-slate-500 mt-0.5">
                  Review, edit and manage submitted queries
                </p> */}
              </div>

              {/* <div className="text-xs text-slate-500">
                {filterqueries.length} records
              </div> */}
            </div>

            {/* LOADING */}
            {loading ? (
              <div className="p-8">

                <div className="space-y-4 animate-pulse">

                  {[1, 2, 3, 4, 5].map((item) => (
                    <div
                      key={item}
                      className="
                        grid
                        grid-cols-5
                        gap-4
                        items-center
                      "
                    >
                      <div className="h-4 bg-slate-100 rounded" />
                      <div className="h-4 bg-slate-100 rounded" />
                      <div className="h-4 bg-slate-100 rounded" />
                      <div className="h-8 bg-slate-100 rounded" />
                      <div className="h-8 bg-slate-100 rounded" />
                    </div>
                  ))}

                </div>

                <p className="text-center text-xs text-slate-400 mt-5">
                  Loading queries...
                </p>

              </div>
            ) : filterqueries.length === 0 ? (

              /* EMPTY STATE */

              <div className="py-14 px-5 text-center">

                <div
                  className="
                    mx-auto
                    w-14
                    h-14
                    rounded-full
                    bg-slate-100
                    text-slate-400
                    flex
                    items-center
                    justify-center
                  "
                >
                  <MdOutlineQueryStats size={28} />
                </div>

                <h3 className="mt-4 text-sm font-semibold text-slate-800">
                  No queries found
                </h3>

                <p className="mt-1 text-sm text-slate-500 max-w-sm mx-auto">
                  There are no queries matching your current
                  search or filters.
                </p>

                {(searchTerm || dates) && (
                  <button
                    type="button"
                    onClick={resetFilters}
                    className="
                      mt-4
                      inline-flex
                      items-center
                      gap-2
                      px-4
                      py-2
                      rounded-lg
                      border
                      border-slate-200
                      bg-white
                      text-slate-600
                      text-sm
                      font-medium
                      hover:bg-slate-50
                      transition
                    "
                  >
                    <BiRefresh size={17} />
                    Clear Filters
                  </button>
                )}

              </div>

            ) : (

              /* DATA TABLE */

              <div className="w-full overflow-x-auto">

                <DataTable
                  value={filterqueries}
                  paginator
                  rows={10}
                  rowsPerPageOptions={[10, 25, 50]}
                  className="w-full  professional-query-table "
                  tableStyle={{
                    minWidth: "1250px",
                    
                  }}
                  paginatorTemplate="
                    FirstPageLink
                    PrevPageLink
                    PageLinks
                    NextPageLink
                    LastPageLink
                    RowsPerPageDropdown
                  "
                  rowHover
                  stripedRows={false}
                  removableSort
                >

                  {/* QUERY ID */}
                  <Column
                    field="id"
                    header="ID"
                    sortable
                    body={ticketIdBodyTemplate}
                    style={{ width: "100px" }}
                    className=""
                  />

                  {/* QUERY HEADING */}
                  <Column
                    field="query_heading"
                    header="Query"
                    sortable
                    body={headingBodyTemplate}
                    style={{ width: "180px" }}
                  />

                  {/* DESCRIPTION */}
                  {/* <Column
                    field="query_description"
                    header="Description"
                    sortable
                    body={descriptionBodyTemplate}
                    style={{ width: "270px" }}
                  /> */}

                  {/* REQUESTED DEPARTMENT AND USER */}
                  <Column
                    field="requested_department"
                    header="Requested Department"
                    sortable
                    body={requestedDepartmentBodyTemplate}
                    style={{ width: "270px" }}
                  />

                  <Column
                    field="requested_department_user"
                    header="Requested User"
                    sortable
                    body={requestedDepartmentUserBodyTemplate}
                    style={{ width: "270px" }}
                  />

                  {/* DEPARTMENT */}
                  <Column
                    field="department"
                    header="Assigned Department"
                    sortable
                    body={departmentBodyTemplate}
                    style={{ width: "150px" }}
                  />

                  {/* IMAGE */}
                  <Column
                    field="image"
                    header="Attachment"
                    body={imageBodyTemplate}
                    style={{ width: "110px" }}
                  />

                  {/* STATUS */}
                  <Column
                    field="status"
                    header="Status"
                    sortable
                    body={statusBodyTemplate}
                    style={{ width: "130px" }}
                  />

                  {/* CREATED */}
                  <Column
                    field="query_created_time"
                    header="Created"
                    sortable
                    body={createdDateBodyTemplate}
                    style={{ width: "175px" }}
                  />

                  {/* CLOSED */}
                  <Column
                    field="query_closed_time"
                    header="Closed"
                    sortable
                    body={closedDateBodyTemplate}
                    style={{ width: "175px" }}
                  />

                  {/* CLOSED BY */}
                  <Column
                    field="closed_by"
                    header="Closed By"
                    sortable
                    body={closedByBodyTemplate}
                    style={{ width: "150px" }}
                  />

                  {/* ACTION */}
                  <Column
                    header="Actions"
                    body={actionBodyTemplate}
                    style={{
                      width: "180px",
                      position: "sticky",
                      right: 0,
                      background: "white",
                      zIndex: 2,
                    }}
                  />

                </DataTable>

              </div>
            )}

          </div>
        )}
      </div>

      {/* =====================================================
          PRIME REACT TABLE OVERRIDES
      ===================================================== */}

      <style>{`
        .professional-query-table .p-datatable-thead > tr > th {
          background: #f8fafc;
          color: #475569;
          font-size: 0.7rem;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.04em;
          padding: 0.85rem 0.9rem;
          border-color: #e2e8f0;
          white-space: nowrap;
        }
          .professional-query-table .p-datatable-tbody > tr > td {
            padding: 5px 10px !important;
            height: 40px !important;
            line-height: 1.1 !important;
            }

        .professional-query-table .p-datatable-tbody > tr > td {
          padding: 0.85rem 0.9rem;
          border-color: #f1f5f9;
          color: #475569;
          font-size: 0.875rem;
          vertical-align: middle;
        }

        .professional-query-table
          .p-datatable-tbody
          > tr:hover {
          background: #f8fafc;
        }

        .professional-query-table .p-paginator {
          background: #ffffff;
          border: 0;
          border-top: 1px solid #e2e8f0;
          padding: 0.65rem 0.85rem;
          justify-content: flex-end;
          gap: 0.15rem;
        }

        .professional-query-table .p-paginator .p-paginator-page,
        .professional-query-table .p-paginator .p-paginator-next,
        .professional-query-table .p-paginator .p-paginator-prev,
        .professional-query-table .p-paginator .p-paginator-first,
        .professional-query-table .p-paginator .p-paginator-last {
          min-width: 2rem;
          height: 2rem;
          border-radius: 0.5rem;
          font-size: 0.75rem;
        }

        .professional-query-table .p-paginator .p-highlight {
          background: #0284c7;
          color: white;
        }

        .professional-query-table .p-dropdown {
          height: 2rem;
          border-radius: 0.5rem;
          border-color: #e2e8f0;
          font-size: 0.75rem;
        }

        .professional-query-table .p-sortable-column-icon {
          width: 0.8rem;
          height: 0.8rem;
        }

        .professional-query-table .p-datatable-wrapper {
          scrollbar-width: thin;
        }

        @media (max-width: 640px) {
          .professional-query-table .p-datatable-thead > tr > th {
            padding: 0.7rem;
          }

          .professional-query-table .p-datatable-tbody > tr > td {
            padding: 0.7rem;
          }

          .professional-query-table .p-paginator {
            justify-content: center;
            flex-wrap: wrap;
          }
        }
      `}</style>
    </div>
  );
}